/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:user
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/21 | 富士通株式会社        | 新規作成
//================================================================================
 */
// 利用者情報
export const user = {
    namespaced: true,
    state: {
        userId: null,
        riyosyaId: null,
        userToken: null,
        role: null,
    },
    getters: {
        // 利用者情報を取得
        getInfo(state) {
            return state;
        },
        // トークンを取得
        getToken(state) {
            return state.userToken;
        },
        // 認証済
        isAuthenticated(state) {
            return !state.userId || !state.userToken ? false : true;
        }
    },
    mutations: {
        // 利用者情報を設定
        setInfo(state, info) {
            state.userId = info.userId;
            state.riyosyaId = info.riyosyaId;
            state.role = info.role;
        },
        // トークン保持
        saveToken(state, token) {
            state.userToken = token;
        },
        // 利用者情報を初期化
        clear(state) {
            state.userId = null;
            state.riyosyaId = null;
            state.userToken = null;
            state.role = null;
        }
    },
    actions: {},
    modules: {}
}